"use client";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useCoverageAreaData from "@/hooks/data/use-coverage-area-data";
import usePopOver from "@/hooks/use-popover";
import ICoverageArea from "@/interfaces/coverage-area.interface";
import { CoverageAreaMessages } from "@/messages/coverage-area/coverage-area.messages";

import { CoverageAreaPopover } from "../Popover";

interface Props {
  coverageArea: ICoverageArea;
  messages: CoverageAreaMessages;
  index: number;
}

export function CoverageAreaTableRow({ coverageArea, index, messages }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<ICoverageArea>();
  const data = useCoverageAreaData({ coverageArea });

  return (
    <TableRow index={index}>
      <TableCell>{data.formattedCepStart}</TableCell>
      <TableCell>{data.formattedCepEnd}</TableCell>
      <TableCell>{data.areaDescription}</TableCell>
      <TableCell>{data.freightType || "-"}</TableCell>
      <TableCell align="center">{data.formattedStartWeight}</TableCell>
      <TableCell align="center">{data.formattedEndWeight}</TableCell>
      <TableCell align="center">{data.formattedFreightChargeOrder}</TableCell>
      <TableCell align="center">{data.formattedFreightCostCarrier}</TableCell>
      <TableCell align="center">{data.regionalDeliveryTime}</TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, coverageArea)}>
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <CoverageAreaPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
